module.exports = __webpack_public_path__ + "img/rope_Braid_1eye_2.b7a2ff85.png";